<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Clientes', 'link' : '/client' },
      ]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Detalhes da Tabela de Preço</span>
      </div>
      <div class="col-6 text-end">
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/tableprice/new', query: { edit: true, id: dados.id } }">
          <i class="bi bi-pencil-fill me-2"></i>Editar
        </router-link>
        <button v-show="isAdmin" @click="showModal_delete()" class="btn btn-sm btn-danger me-2"><i class="bi bi-trash3-fill me-2"></i>Deletar</button>
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show"/>

    <div v-if="dados.id != null" class="row">
      <div class="col mx-auto " style="margin-bottom: 40px;" id="conteudoParaImprimir">
        <div class="card mb-2">
          <div class="card-body">
            <span class="mb-2 fw-bold">Nome: {{ dados.name }}</span>
          </div>
        </div>

        <app-table v-if="dados.items.length != 0" empty-message='nada encontrado'
        :colunas="[{ label: 'Nome' }, {label: 'Preço'},]">
            <app-trow
                v-for="item in dados.items" :key="item.id"
                :data="[
                {value: item.item.name},
                {value: item.price},
                ]"
            >
            </app-trow>
        </app-table>

      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Modal de Delete -->
    <div class="modal fade" id="modal_delete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Confirmar Exclusão</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
            <p class="mt-3">Tem certeza que deseja excluir o cliente: <strong>{{ dados.name }}</strong></p>
            <p class="text-muted small">Esta ação não pode ser desfeita e pode afetar o estoque.</p>
          </div>
          <div class="modal-footer">
              <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
              <button type="button" @click="confirmExcluir" :disabled="deleteLoading" class="btn btn-danger">
                <span v-if="deleteLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Excluir</span>
              </button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import { usePermissions } from '@/composables/usePermissions';
import { parseError } from '@/utils/errorHelper';
import { Modal } from "bootstrap";
import { useToastStore } from '@/stores/toastStore';
import PainelLayout from '@/layouts/PainelLayout.vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import statusFormat from '@/services/statusFormat.js';
import dateFormat from '@/services/dateFormat';
import router from '@/router';
import { tableprice } from '@/models/tableprice';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "DetailsView",
  components: { PainelLayout, Breadcrumb, AppTable, AppTrow },
  setup(props) {

    const { isAdmin,isOpeto,isUser } = usePermissions();
    var modal = '';
    const urlReturn = '/tableprice';
    var deleteLoading = ref(false);
    const model = tableprice();
    const toastStore = useToastStore();

    function goReturn() {
      router.push(urlReturn);
    }

    var dados = reactive({
      id: null,
      name: null,
      items: []
    });

    function imprimir() {
      window.print();
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete() {
      openModal('modal_delete');
    }

    function confirmExcluir() {
      deleteLoading.value = true;
      model.delet(dados.id).then(() => {
        toastStore.success('Cliente excluído com sucesso.');
        closeModal();
        goReturn();
      }).catch((error) => {
        deleteLoading.value = false;
        toastStore.error('Erro ao excluir cliente: ' + parseError(error));
      });
    }

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id');

      model.getOne(id).then((response) => {
          dados.id = response.id;
          dados.name = response.name;
          dados.items = response.items;
      });
    });

    return {
      dados,isAdmin,isOpeto,isUser,
      statusFormat,goReturn, urlReturn, parseError,
      dateFormat, deleteLoading, showModal_delete, closeModal, confirmExcluir,
      imprimir
    }
  }
}
</script>

<style scoped>

</style>